import { Navigate, NavLink, Outlet, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_STORY_CARD_MODULES } from '../../../constants/adminModules'
import { ADMIN_DASHBOARD_PATH } from '../../../constants/adminRoutes'

export function StoryCardsIndexRedirect() {
  const { hasModuleAccess } = useAuth()
  const first = ADMIN_STORY_CARD_MODULES.find(({ key }) => hasModuleAccess(key))

  if (!first) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  return <Navigate to={`/cp-login/story-cards/${first.route}`} replace />
}

export default function AdminStoryCardsLayout() {
  const { t } = useTranslation()
  const { hasModuleAccess } = useAuth()
  const { cardType } = useParams()

  const visibleNav = ADMIN_STORY_CARD_MODULES.filter(({ key }) => hasModuleAccess(key))

  if (!visibleNav.length) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  if (cardType && !visibleNav.some(({ route }) => route === cardType)) {
    return <Navigate to={`/cp-login/story-cards/${visibleNav[0].route}`} replace />
  }

  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-primary">{t('admin.storyCards.title')}</h1>
        <p className="mt-1 text-sm text-text/60">{t('admin.storyCards.subtitle')}</p>
      </div>

      <nav className="mb-6 flex flex-wrap gap-2 border-b border-border pb-4">
        {visibleNav.map(({ route, labelKey }) => (
          <NavLink
            key={route}
            to={`/cp-login/story-cards/${route}`}
            className={({ isActive }) =>
              `rounded-xl px-4 py-2 text-sm font-medium transition-colors ${
                isActive ? 'bg-primary text-white' : 'bg-primary/5 text-primary hover:bg-primary/10'
              }`
            }
          >
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  )
}
